import { CONCEPT_EXPRESSIONS_LOCALSTORAGE_KEY } from './constants';
import { EntityFieldConceptExps } from './reducer';
import { fromPredicate } from 'fp-ts/lib/Option';
import storage from 'local-storage-fallback';

const initialize = (): EntityFieldConceptExps => {
    return fromPredicate<string>(Boolean)(storage.getItem(CONCEPT_EXPRESSIONS_LOCALSTORAGE_KEY))
        .map(serializedConceptExpressions => JSON.parse(serializedConceptExpressions))
        .getOrElse({});
};
export default initialize;
